module.exports = __webpack_public_path__ + "static/wireframe-tab-05885079e0d091b8e6fc564126e623e7.png";